import { render, staticRenderFns } from "./NewsDetail.vue?vue&type=template&id=1718d70a&scoped=true"
import script from "./NewsDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./NewsDetail.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1718d70a",
  null
  
)

export default component.exports